export const QUERY__BANNERS = 'banners';
